import React, { useState, useEffect, useRef, ReactNode } from "react";
import styled from "styled-components";

interface LazyLoadProps {
  children: ReactNode;
  fallback?: ReactNode;
  rootMargin?: string;
  threshold?: number;
  className?: string;
}

const LazyContainer = styled.div`
  min-height: 100px; /* レイアウトシフトを防ぐための最小高さ */
`;

const LazyLoad: React.FC<LazyLoadProps> = ({
  children,
  fallback,
  rootMargin = "200px", // ビューポートから200pxの距離で読み込み開始
  threshold = 0.1,
  className,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasLoaded) {
          setIsVisible(true);
          setHasLoaded(true);
          // コンポーネントが読み込まれたら監視を停止
          if (elementRef.current) {
            observer.unobserve(elementRef.current);
          }
        }
      },
      {
        rootMargin,
        threshold,
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [rootMargin, threshold, hasLoaded]);

  return (
    <LazyContainer ref={elementRef} className={className}>
      {isVisible ? children : fallback}
    </LazyContainer>
  );
};

export default LazyLoad;